(() => {
  if (window.ashmoreReferenceReady) return;
  window.ashmoreReferenceReady = true;
  const updateQuantity = () => {
    document.querySelectorAll('.al-reference-product .product-form__quantity').forEach((container) => {
      const input = container.querySelector('input[name="quantity"]');
      if (!input) return;
      const hasRules = Number(input.dataset.min || 1) > 1 || Number(input.step || 1) > 1 || Boolean(input.dataset.max);
      container.classList.toggle('al-reference-quantity-hidden', !hasRules);
    });
  };
  const start = () => {
    updateQuantity();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, updateQuantity);
      subscribe(PUB_SUB_EVENTS.variantChange, updateQuantity);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', updateQuantity);
  document.addEventListener('product-info:loaded', updateQuantity);
})();
